﻿import React from 'react';
import {CardItemValue} from "../CardItemValue";
import {styled} from "@mui/styles";

const Root = styled(CardItemValue)(() => ({
  color: '#3F51B5',
  cursor: 'pointer',
}));

type CardItemValueWithLinkProps = React.ComponentPropsWithoutRef<'span'>;

/**
 * MUI Typography component styled in the SecurSpace way. Any of its variations can be used in an ItemContainer in combination
 * with an ItemLabel to create a duo capable of toppling all existence in their styled ways
 * @param children children passed through to the internal Typography component
 * @param props The rest of the Typography props that will be passed through to the internal Typography component
 * @constructor
 */
const CardItemValueWithLink = ({ children, ...props}: CardItemValueWithLinkProps) => {
  return <Root {...props}>
    { children }
  </Root>
}

export { CardItemValueWithLink };
